import { Component, OnInit, Signal, computed } from '@angular/core';
import { analystSourcesWhiteList } from '@configurations/scenario/analyst-sources-white-list.configuration';
import { Source } from '@scenario/models/source.model';
import { dispatch, select } from '@store/injectables';
import {
  AnalystViewModel,
  retrievePsfUsers,
  selectAnalystViewModel,
} from '@store/scenario/analyst/analyst-slice';
import {
  MarketAreasViewModel,
  retrieveMarketAreas,
  selectMarketAreasViewModel,
} from '@store/scenario/market-areas/market-areas-slice';
import {
  RegionManagerViewModel,
  retrieveRegionManagers,
  selectRegionManagerViewModel,
} from '@store/scenario/region-manager/region-manager-slice';
import {
  SourcesViewModel,
  retrieveSources,
  selectSourcesViewModel,
} from '@store/scenario/sources/sources-slice';
import { IconComponent } from '@totalenergiescode/tds-angular';
import { RegionManagerSectionComponent } from '../region-manager-section/region-manager-section.component';

@Component({
  selector: 'app-manage-region-manager',
  templateUrl: './manage-region-manager.component.html',
  styleUrl: './manage-region-manager.component.scss',
  imports: [IconComponent, RegionManagerSectionComponent],
})
export class ManageRegionManagerComponent implements OnInit {
  private readonly dispatch = dispatch();
  public readonly regionManagerViewModel: Signal<RegionManagerViewModel> = select(selectRegionManagerViewModel);
  public readonly analystViewModel: Signal<AnalystViewModel> = select(selectAnalystViewModel);
  public readonly sourcesViewModel: Signal<SourcesViewModel> = select(selectSourcesViewModel);
  public readonly marketAreasViewModel: Signal<MarketAreasViewModel> = select(selectMarketAreasViewModel);
  public readonly whiteListedSources = computed<Source[]>(() => {
    const sourcesByName = new Map(this.sourcesViewModel().sources.map(source => [source.name, source]));
    return analystSourcesWhiteList
      .map(name => sourcesByName.get(name))
      .filter((source): source is Source => source !== undefined);
  });

  ngOnInit(): void {
    this.dispatch(retrieveSources());
    this.dispatch(retrieveRegionManagers());
    this.dispatch(retrieveMarketAreas());
    this.dispatch(retrievePsfUsers());
  }
}
